$('.try-dropdown__input').on('change', function(){
    var value = $(this).data('try-tab');

    $('.try-popup__tab').hide();
    $('.try-popup__info').hide();
    $('.try-popup__main-' + value).fadeIn();
    $('.try-popup__info-' + value).fadeIn();
});